/**
 *	Easing - linear
 */

export const linear = (t: number) => t * t;
